import { connect } from 'react-redux';
import { compose } from 'redux';
import { withContext, getContext, withHandlers,lifecycle } from 'recompose'
import PropTypes from 'prop-types'

import ControlledComponent from '../components/Report'



import {generateAssessmentsByEmployee,generateAssessmentsByEmployeeId} from '../actions'
import firebase from 'firebase/app'

function mapStateToProps(state, ownProps) {
  
    const { store, firebase: { auth, profile},asyncMessage, selectedAssessment, summarizedCps  } = state
    
    return {
        store,
        auth, profile,
        asyncMessage,
        selectedAssessment,
        summarizedCps

    }
    
  }

const mapDispatchToProps = (dispatch, ownProps) => {
    
    return {   
        generateAssessments: (assessment) => {
            const { employeeRef, employee} = assessment
            const { store } = ownProps
            dispatch(generateAssessmentsByEmployee(employeeRef,employee,store,false))
        },
        generateAssessmentsByEmployeeId: () => {
            const { assessment: { employeeId}, store } = ownProps
            dispatch(generateAssessmentsByEmployeeId(employeeId,store,false))
        },
        generateWithShowCount: () => {
            const { assessment: { employeeId}, store } = ownProps
            dispatch(generateAssessmentsByEmployeeId(employeeId,store,true))
        },
        load: () => {
            const { assessment } = ownProps
            console.log(assessment)
            const promises = assessment.activities.map(activity => {
                activity.data.competencies 
                ? activity.data.competencies.map(cp => {
                    
                    return cp
                    })
                : {docs:[]}
            })

            Promise.all(promises).then(snapshots => snapshots.map(snapshot => 
                    snapshot
                        ? snapshot.docs.map(doc => console.log(doc.id))  
                        : null
                ))
            
        }

        /*
        generateReport: (assessment) => { 
            const formatted = formatAssessment(assessment)
            insertWordTable(formatted) 
        },
        */
    }
}

const withStore = compose(
    withContext({ store: PropTypes.object }, () => {}),
    getContext({ store: PropTypes.object }),
  )
  
export default compose(
    withStore,
    connect(
        mapStateToProps,
        mapDispatchToProps,
      )
)(ControlledComponent)


// WEBPACK FOOTER //
// ./src/assessments/containers/Report.js